import type { StoryBeat } from '../types/offer'

export const storyBeats: StoryBeat[] = [
  {
    id: 'gancho',
    number: '01',
    tag: 'El Gancho',
    lead: '¿Alguna vez has sentido que, por más que intentas usar la Inteligencia Artificial, tus resultados siguen pareciendo... "de IA"? Genéricos, deformes, aburridos. Mientras tanto, ves a grandes creadores y marcas de lujo publicando videos imposibles que se vuelven virales en horas.',
    punch: 'La diferencia no es la herramienta. Es el código.',
    tone: 'neutral'
  },
  {
    id: 'agitacion',
    number: '02',
    tag: 'Agitación del Dolor',
    lead: 'Estamos en 2026. El scroll del usuario es más rápido que nunca. Si tus anuncios, tus posts o tus videos parecen "el contenido de siempre", eres invisible. Estás tirando dinero en Ads que nadie ve y perdiendo clientes que se van con el competidor que sí sabe impactar visualmente. La mayoría de los emprendedores están atrapados usando prompts básicos de ChatGPT, preguntándose por qué no tienen resultados.',
    punch: 'El costo de ser "promedio" hoy es la quiebra digital.',
    tone: 'danger'
  },
  {
    id: 'revelacion',
    number: '03',
    tag: 'La Revelación',
    lead: 'Después de analizar miles de horas de contenido viral y gastar miles de dólares probando cada parámetro en Midjourney y Runway, descubrimos algo. Hemos condensado esta fórmula en un arsenal masivo que permite a cualquiera, desde un principiante hasta un dueño de agencia, generar visuales que detienen el corazón.',
    punch:
      'La Disrupción Visual tiene una fórmula matemática. No es talento, es ingeniería de comandos.',
    tone: 'gold'
  }
]
